import { Styles, css } from '@flipster/styled-system/css';
import { center } from '@flipster/styled-system/patterns';

interface SpinnerProps {
  color?: 'white' | 'gray';
  size?: number;
  css?: Styles;
}

export const Spinner = ({ color = 'white', size = 48, css: cssProp }: SpinnerProps) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={size}
      height={size}
      viewBox='0 0 48 48'
      className={css(
        {
          fill: color === 'white' ? 'inverse.white' : 'gray.300',
          animationDuration: '1s',
          animationTimingFunction: 'linear',
          animationIterationCount: 'infinite',
          animationName: 'rotate',
        },
        cssProp,
      )}
    >
      <path d='M48 24C48 28.1064 46.9464 32.1441 44.9399 35.7269C42.9334 39.3097 40.0412 42.3178 36.54 44.4634C33.0387 46.6089 29.0455 47.8203 24.9422 47.9815C20.839 48.1427 16.763 47.2484 13.1042 45.3842C9.4454 43.5199 6.32612 40.748 4.04473 37.3337C1.76334 33.9193 0.396167 29.9767 0.0739837 25.883C-0.248199 21.7893 0.485385 17.6814 2.20457 13.9522C3.92375 10.223 6.57102 6.99726 9.89316 4.58359L12.7145 8.46687C10.0568 10.3978 7.939 12.9784 6.56365 15.9617C5.18831 18.9451 4.60144 22.2314 4.85919 25.5064C5.11693 28.7814 6.21067 31.9355 8.03578 34.6669C9.86089 37.3984 12.3563 39.6159 15.2834 41.1073C18.2104 42.5987 21.4712 43.3142 24.7538 43.1852C28.0364 43.0562 31.231 42.0872 34.032 40.3707C36.833 38.6542 39.1467 36.2478 40.7519 33.3815C42.3571 30.5153 43.2 27.2851 43.2 24H48Z' />
    </svg>
  );
};

interface SpinnerBoxProps extends Omit<SpinnerProps, 'css'> {
  css?: Styles;
}

export const SpinnerBox = ({ color = 'white', size = 48, css: cssProps }: SpinnerBoxProps) => {
  return (
    <div className={css(center.raw({ w: '100%', h: '100%' }), cssProps)}>
      <Spinner color={color} size={size} />
    </div>
  );
};
